import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
// import FormSelectionField from "../../components/formFields/FormSelectionField";
// import { STATUSARRAY } from "../../_contstants/common";
import {
  getAllGallerys,
  getGalleryByID,
  updateGallery,
} from "./services/gallery.services";
import { clearGalleryDetails } from "./gallerySlice";
import { RxCross1 } from "react-icons/rx";
import { closed } from "../../components/drawer/drawerSlice";
import FormImageUpload from "../../components/formFields/FormImageUpload";
import IconButton from "../../components/common/IconButton";
import { getFile } from "../../_helper/helper";
import FormCheckbox from "../../components/formFields/FormCheckbox";

const CreateGallery: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const location = useLocation();
  // const GalleryID = location.state?.GalleryID;
  const GalleryID = useAppSelector((state) => state.drawer.data);
  const GalleryDetail = useAppSelector((state) => state.gallery.GalleryDetail);
  const loading = useAppSelector((state) => state.gallery.formLoading);
  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    if (GalleryID) {
      dispatch(getGalleryByID(GalleryID));
    }
    return () => {
      dispatch(clearGalleryDetails());
    };
  }, [GalleryID]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [GalleryDetail]);

  const handleSubmit = async (values: any) => {
    const GroupName = values?.GroupName ? values?.GroupName : "";
    const ImgAlt = values?.ImgAlt ? values?.ImgAlt : "";
    const ImageData = new FormData();
    const Image =
      values?.GalleryImage && typeof values?.GalleryImage !== "string"
        ? getFile(values.GalleryImage)
        : "";

    try {
      if (GalleryID) {
        if (values?.GalleryImage && typeof values?.GalleryImage !== "string") {
          ImageData.append("ImageFile", Image);
        }
        ImageData.append("IsshowHome", values.IsshowHome);
        ImageData.append("GroupName", GroupName);
        ImageData.append("ImgAlt", ImgAlt);
        ImageData.append("ID", GalleryID);
        const response = await dispatch(updateGallery(ImageData));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(getAllGallerys());
          dispatch(clearGalleryDetails());
        }
      } else {
        if (values?.GalleryImage && typeof values?.GalleryImage !== "string") {
          ImageData.append("GroupName", GroupName);
          ImageData.append("ImgAlt", ImgAlt);
          ImageData.append("IsshowHome", values.IsshowHome);
          ImageData.append("ImageFile", Image);
          const response = await dispatch(updateGallery(ImageData));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(closed());
            dispatch(getAllGallerys());
            dispatch(clearGalleryDetails());
          }
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={GalleryDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout gap={{ rows: 0, cols: 0 }} cols={[{ width: "100%" }]}>
                <GridLayoutItem className="master-drawer-header">
                  <Typography.h4 className="m-0">
                    {GalleryID ? "Update Gallery" : "Create Gallery"}
                  </Typography.h4>
                  <IconButton
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                    icon={RxCross1}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    justifyContent="start"
                    name="GalleryImage"
                    label="Image"
                    type="file"
                    accept="image/*"
                    alternateName="Image"
                    component={FormImageUpload}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="ImgAlt"
                    label="Img Alt"
                    placeholder="Img Alt"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="GroupName"
                    label="Group Name"
                    placeholder="Group Name"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    width: "100%",
                    margin: "18px 0px 0px",
                    padding: "0px 10px 8px",
                    fontWeight: 700,
                    background: "whitesmoke",
                    borderRadius: 5,
                    height: 48,
                  }}
                >
                  <Field
                    name="IsshowHome"
                    label="Show at Home"
                    placeholder="Show at Home"
                    component={FormCheckbox}
                    labelClassName="fw-600"
                  />
                </GridLayoutItem>

                {/* <GridLayoutItem>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    placeholder="i.e. Active"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem> */}

                <GridLayoutItem
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={GalleryID ? "Update" : "Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateGallery;
